import { IKnmPlanRaw } from 'APIPackage/PlanListModule/interfaces/IKnmPlanRaw';
import {
  DATE_FORMAT_FULL_FNS,
  DATE_FORMAT_ISO_FNS,
  DATE_FORMAT_LONG_FNS,
} from 'CorePackage/MainModule/constants/dateFormats';
import { formatDate, parseDate } from 'CorePackage/MainModule/common/formatDate';

import { IKnmPlan } from '../interfaces/IKnmPlan';

export function mapRawToPlan(raw: IKnmPlanRaw): IKnmPlan {
  const startDate = parseDate({ date: raw.startDate, parseFormat: DATE_FORMAT_LONG_FNS });
  const endDate = parseDate({ date: raw.endDate, parseFormat: DATE_FORMAT_LONG_FNS });
  const startYear = startDate ? startDate.getFullYear() : undefined;
  const endYear = endDate ? endDate.getFullYear() : undefined;
  const created =
    formatDate({
      date: raw.created,
      dateFormat: DATE_FORMAT_FULL_FNS,
      parseFormat: DATE_FORMAT_ISO_FNS,
    }) || '-';
  const updated =
    formatDate({
      date: raw.updated,
      dateFormat: DATE_FORMAT_FULL_FNS,
      parseFormat: DATE_FORMAT_ISO_FNS,
    }) || '-';

  return {
    ...raw,
    period: `${startDate ? raw.startDate : '?'} - ${endDate ? raw.endDate : '?'}`,
    created,
    updated,
    signed: raw.signed ? 'Подписан' : 'Не подписан',
    year: startYear || endYear,
  };
}
